<template>
  <div class="feedback">
    <base-son-title 
        enTitle="Warranty Policy" 
        title="服务" title1="反馈" 
        class="animate__animated animate__zoomIn"
      >
    </base-son-title>
    <div class="content animate__animated animate__zoomIn">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-form-item class="rack-number" prop="vin">
            <div class="title-box">
              <label class="text-1">填写车架号</label>
              <label class="text-2">Frame Number</label>
            </div>
            <div class="input-box">
              <el-input v-model="form.vin" placeholder="请输入"></el-input>
              <el-button type="primary" class="binding-btn" @click="bindBtn">绑定</el-button>
            </div>
            <div class="hint">
              <p>注：绑定车架号才可继续填写以下内容</p>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item class="shop-select" prop="store_id">
              <div class="title-box">
                  <label class="text-1">门店选择</label>
                  <label class="text-2">Store</label>
              </div>
              <el-select class="shop-select1" v-model="form.store_id" filterable placeholder="请选择" :disabled="isDisavled">
                <el-option v-for="(item,idx) in storeList" :key="idx" :label="item.storeName" :value="item.storeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="motorcycle-type" prop="goods_id">
              <div class="title-box">
                  <label class="text-1">车型</label>
                  <label class="text-2">Car model</label>
              </div>
              <el-input v-model="form.goods_id" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="phone" prop="mobile">
              <div class="title-box">
                  <label class="text-1">联系电话</label>
                  <label class="text-2">Phone</label>
              </div>
              <el-input v-model="form.mobile" placeholder="请输入" :disabled="isDisavled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <el-form-item class="opinion" prop="content">
              <div class="title-box">
                  <label class="text-1">反馈意见</label>
                  <label class="text-2">Opinion</label>
              </div>
              <el-input type="textarea" v-model="form.content" placeholder="请输入" :disabled="isDisavled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="video-photo">
              <div class="title-box">
                  <label class="text-1">视频或图片</label>
                  <label class="text-2">Video/Photo</label>
              </div>
              <el-upload
                action="http://up-z2.qiniup.com"
                list-type="picture-card"
                :auto-upload="false"
                ref="upload"
                :on-remove="handleRemove"
                :disabled="isDisavled"
                :limit="1"
                :data="upload_data"
                :on-change="handleChange"
                :class="{uoloadSty:showBtnImg,disUoloadSty:noneBtnImg}"
                >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="btn">
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import BaseSonTitle from "@/components/BaseSonTitle.vue";
import { bindVINApi, feedbackSubmitApi, storesChooseApi, uploadApi, vinOutApi } from "../../../../request/api";
export default {
  components:{
    BaseSonTitle,
  },
  data(){
    return{
      upload_data:{}, //上传时的额外参数
      showBtnImg:true,  //显示上传图标按钮
      noneBtnImg:false,  //不显示上传图标按钮
      isDisavled:true,
      fileList:[],
      dialogImageUrl: '',
      disabled: false,
      storeList:[], //门店列表
      form:{
        vin:'', //请填写车架号
        store_id:'', //门店选择
        goods_id:'', //请选择车型
        mobile:'', //手机号
        content:'', //反馈意见
      },
      rules: {
        vin: [
          { required: true, message: '请填写车架号', trigger: 'blur' },
        ],
        store_id: [
          { required: true, message: '请选择门店', trigger: 'blur' }
        ],
        goods_id: [
          { required: true, message: '请选择车型', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入反馈意见', trigger: 'blur' }
        ],
      },
    }
  },
  watch:{
    fileList(){
      if (this.fileList.length>0) {
        this.get_token()
      }
    }
  },
  created(){
    this.storesChooseApi()
    this.get_token()
  },
  methods:{
    //车架号带出车型
    vinOutApi(vin){
      vinOutApi({vin:vin}).then(({data})=>{
        this.form.goods_id = data.result.itemName
      })
    },
    // 门店列表数据
    storesChooseApi(){
      let params = {
        condition:''
      }
      storesChooseApi(params).then(({data})=>{
        this.storeList = data.result
      })
    },
    // 获取七牛云上传的token
    get_token() {
      const params = {
        m:'Mobile',
        c:'Upload',
        a:'qiniu_key',
      }
      uploadApi(params).then(({data})=>{
        this.upload_data.token = data.datas.token
      })
    },
    // 上传文件列表
    handleChange(file,fileList){
      this.noneBtnImg = true   //不显示上传按钮
			this.showBtnImg = false  //显示上传按钮
      this.fileList = fileList
    },
    // 删除
    handleRemove(file,fileList) {
      this.noneBtnImg = false   //不显示上传按钮
			this.showBtnImg = true  //显示上传按钮
    },
    // 车架号绑定
    bindBtn(){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'binding',
        vin:this.form.vin
      }
      bindVINApi(params).then(({data})=>{
        this.$message({
          message: data.datas.error ? data.datas.error : data.datas,
          type: data.datas.error ? 'error' : 'success'
        })
        data.datas.error ? this.isDisavled = true : this.isDisavled = false
      })
      this.vinOutApi(this.form.vin)
    },
    // 提交
    onSubmit(formName){
      if (this.fileList.length == 0) {
        this.$message.error('请上传图片或视频')
      }else{
        this.$refs.upload.submit()
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            m:'Mobile',
            c:'MajorProduct',
            a:'web_message'
          }
          let obj = Object.assign({},this.form,params)
          feedbackSubmitApi(obj).then(({data})=>{
            this.$message.success(data.datas)
          })
        } else {
          this.$message.erorr('提交失败!')
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss">
.feedback{
  width: 1100px;
  margin: 0 auto;
  .content{
    padding: 50px 0;
    .rack-number{
      .input-box{
        display: flex;
        justify-content: space-between;
      }
      .title-box{
        width: 610px;
        display: flex;
        justify-content: space-between;
        .text-1::before{
          content: '*';
          color: red;
        }
        .text-2{
          color: #717171;
        }
      }
      .binding-btn{
        margin-left: 20px;
        color: black;
        border-radius: 25px;
        background-color: #FBCC0A;
        width: 113px;
        border-color: #FBCC0A;
      }
      .el-form-item__content{
        width: 730px;
      }
      .hint{ color: red; }
    }
    .shop-select,.motorcycle-type,.phone{
      .title-box{
        width: 240px;
        display: flex;
        justify-content: space-between;
        .text-1::before{
          content: '*';
          color: red;
        }
        .text-2{
          color: #717171;
        }
      }
      .el-select,.el-input{
        width: 240px;
      }
      .el-input__inner{
        height: 40px !important;
      }
    }
    .opinion{
      .title-box{
        width: 605px;
        display: flex;
        justify-content: space-between;
        .text-1::before{
          content: '*';
          color: red;
        }
        .text-2{
          color: #717171;
        }
      }
      .el-textarea__inner{
        width: 605px;
        height: 180px;
      }
    }
    .video-photo{
      .title-box{
        width: 240px;
        display: flex;
        justify-content: space-between;
        .text-1::before{
          content: '*';
          color: red;
        }
        .text-2{
          color: #717171;
        }
      }
      .el-input{
        width: 240px;
      }
      .uoloadSty .el-upload--picture-card{
        width: 240px;
        height: 180px;
        .el-icon-plus{
          line-height: 6;
        }
      }
      .el-upload-list--picture-card .el-upload-list__item{
        width: 240px;
        height: 180px;
        img{
          object-fit: cover;
        }
      }
      .disUoloadSty .el-upload--picture-card{
        display:none;   /* 上传按钮隐藏 */
      }
      
      
    }
    .btn{
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .el-button{
        width: 212px;
        height: 48px;
        border-radius: 25px;
        background-color: #FBCC0A;
        border-color: #FBCC0A;
        color: black;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/serve/feedback/feedback.vue